export const getOriginPercentage = (value: string) => {
  const percentage =
    (Number(value.replaceAll('%', '')) / 100) *
    Number(localStorage.getItem('valor_fundo'));
  const currentBalance =
    Number(localStorage.getItem('valor_fundo')) - percentage;

  return currentBalance;
};
